import React, { FC, useEffect, useState } from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input,Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import styles from './Profile.module.scss';
import { showErrorMessage } from '../../helpers/utils/ui';
import { profileApi } from '../../shared/common/api/endpoints/profileApi';
import MainLayout from '../../shared/common/components/layouts/MainLayout';
import Loader from '../../shared/common/components/loader/Loader';
import PageHead from '../../shared/common/components/page-header/PageHeader';
import { useActions } from '../../shared/common/hooks/useActions';
import { useTypedSelector } from '../../shared/common/hooks/useTypedSelector';

const Profile: FC = () => {
    const navigate = useNavigate();

    const { name, email, phone, isLoading, telegram_connect, max_connect } = useTypedSelector((state) => state.currentUser);
    const { updateUserInfo, updateUserPassword, fetchUserAndSchoolInfo, setAppReportOpen, setDrawerLink } = useActions();

    const instructionBtn = (
        <span
            style={{
                marginLeft: 10,
                marginRight: 10,
                marginTop: 3,
                cursor: 'pointer',
            }}
            onClick={() => {
                try {
                    setDrawerLink('https://doc.scananalytics.ru/interfejs/profil-polzovatelya/');
                    setAppReportOpen(true);
                } catch (err) {
                    console.error(err);
                }
            }}
        >
            <QuestionCircleOutlined
                style={{ color: '#ccc', fontSize: 14, marginTop: '8px', marginLeft: '-10px' }}
            />
        </span>
    );

    const [ contactForm ] = Form.useForm();
    const [ passwordForm ] = Form.useForm();
    const [ tgInfo,setTgInfo ] = useState({
        url:'',
        name:''
    });
    const [ maxInfo,setMaxInfo ] = useState({
        url:'',
        name:''
    });

    const userDefaultValues = {
        name,
        email,
        phone
    };

    const saveContactsData = (values: any) => {
        updateUserInfo(values, () => {
            fetchUserAndSchoolInfo(navigate);
        });
    };

    const savePasswordData = (values: any) => {
        updateUserPassword(values);
    };
useEffect(()=>{
    const handleClick = () => {

        profileApi
            .getConnectTelegramLink()
            .then((response) => {
                if (response.status === 200) {
                    setTgInfo({ url: response.data.telegram_url,name: response.data.nikname });
                }
            })
            .catch(() => {
                showErrorMessage(
                    'Ошибка при получении ссылки. Повторите попытку позже.'
                );
            });
    };
    handleClick();

    // Ссылка для привязки MAX: альтернатива Telegram, достаточно одного мессенджера
    profileApi
        .getConnectMaxLink()
        .then((response) => {
            if (response.status === 200) {
                setMaxInfo({ url: response.data.max_url, name: response.data.nikname });
            }
        })
        .catch(() => {
            showErrorMessage(
                'Ошибка при получении ссылки на MAX. Повторите попытку позже.'
            );
        });
},[]);
    return (
        <MainLayout pageTitle="Профиль">
            <div className="page-wrapper">
                <PageHead title="Профиль" extraContent={instructionBtn} />

                <div className="page-content">
                    <Loader loading={isLoading}>
                        <div className={styles.profileWrapper}>
                            <Card
                                data-help-id="profile-contacts"
                                title="Контактные данные"
                                style={{ width: 310 }}
                            >
                                <Form
                                    form={contactForm}
                                    layout="vertical"
                                    onFinish={saveContactsData}
                                    initialValues={userDefaultValues}
                                    requiredMark={false}
                                >
                                    <Form.Item
                                        label="Имя"
                                        name="name"
                                        rules={[ { required: true, type: 'string', message: 'Введите имя' } ]}
                                    >
                                        <Input />
                                    </Form.Item>

                                    <Form.Item
                                        label="Телефон"
                                        name="phone"
                                    >
                                        <Input disabled />
                                    </Form.Item>

                                    <Form.Item
                                        label="Email"
                                        name="email"
                                        rules={[ { required: true, type: 'email', message: 'Введите email' } ]}
                                    >
                                        <Input disabled />
                                    </Form.Item>

                                    <Button
                                        type="primary"
                                        onClick={() => contactForm.submit()}
                                    >
                                        Сохранить
                                    </Button>
                                </Form>
                            </Card>

                            <Card
                                data-help-id="profile-password"
                                title="Смена пароля"
                                style={{ width: 310 }}
                            >
                                <Form
                                    form={passwordForm}
                                    layout="vertical"
                                    onFinish={savePasswordData}
                                    requiredMark={false}
                                >
                                    <Form.Item
                                        label="Старый пароль"
                                        name="password"
                                        rules={[ { required: true, message: 'Введите старый пароль.' } ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>

                                    <Form.Item
                                        label="Новый пароль"
                                        name="new_password"
                                        rules={[ { required: true, message: 'Введите пароль.' } ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>
                                    <Form.Item
                                        label="Новый пароль еще раз"
                                        name="new_password2"
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Введите пароль еще раз.',
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue('new_password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('Пароли должны совпадать.'));
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input.Password />
                                    </Form.Item>

                                    <Button
                                        type="primary"
                                        onClick={() => passwordForm.submit()}
                                    >
                                        Сохранить
                                    </Button>
                                </Form>
                            </Card>
                            <Card data-help-id="profile-telegram" title="Telegram" bodyStyle={{ display:'flex',flexDirection:'column',rowGap:'10px',alignItems:'flex-start' }} style={{ width: 310 }}>
                                {/* Привязка добровольная: если аккаунт ещё не привязан, показываем
                                    приглашение и кнопку «Привязать», иначе — ник и «Перепривязать» */}
                                <Typography.Text style={{ fontSize:'18px' }} strong>
                                    {telegram_connect && tgInfo.name ? tgInfo.name : 'Telegram не привязан'}
                                </Typography.Text>
                                <Button onClick={()=>window.location.href = tgInfo.url} type={'primary'}>
                                    {telegram_connect ? 'Перепривязать' : 'Привязать Telegram'}
                                </Button>
                            </Card>
                            <Card data-help-id="profile-max" title="MAX" bodyStyle={{ display:'flex',flexDirection:'column',rowGap:'10px',alignItems:'flex-start' }} style={{ width: 310 }}>
                                {/* Достаточно привязать один мессенджер: Telegram или MAX */}
                                <Typography.Text style={{ fontSize:'18px' }} strong>
                                    {/* в MAX ник необязателен: если его нет, приходит имя — тогда без «@» */}
                                    {max_connect
                                        ? (maxInfo.name
                                            ? (/^[A-Za-z0-9_.]+$/.test(maxInfo.name) ? `@${maxInfo.name}` : maxInfo.name)
                                            : 'MAX привязан')
                                        : 'MAX не привязан'}
                                </Typography.Text>
                                <Button
                                    disabled={!maxInfo.url}
                                    onClick={()=>window.location.href = maxInfo.url}
                                    type={'primary'}
                                >
                                    {max_connect ? 'Перепривязать' : 'Привязать MAX'}
                                </Button>
                            </Card>
                        </div>
                    </Loader>
                </div>
            </div>
        </MainLayout>
    );
};

export default Profile;
